export default __webpack_public_path__ + "static/media/download-csv-icon.34064137.svg";